{
  "headings": {
    "login": "Einloggen",
    "forgotten": "Ich habe mein Passwort vergessen",
    "confirmation": "E-Mail gesendet",
    "sending": "E-Mail wird gesendet...",
    "setPass": "Stellen Sie Ihr Passwort ein",
    "startYourFreeTrial": "Starten Sie Ihre kostenlose Testversion."
  },
  "subHeadings": {
    "freeTrial": "Kostenlose 30-Tage-Testversion. Keine Kreditkarte erforderlich.",
    "login": "Um auf Ihr Iventis-Konto zuzugreifen, geben Sie zunächst Ihre E-Mail-Adresse ein.",
    "forgotten": "Geben Sie die mit Ihrem Iventis-Konto verknüpfte E-Mail-Adresse ein und wir senden Ihnen eine E-Mail, um Ihr Passwort zurückzusetzen.",
    "confirmation": "Suchen Sie in Ihrer E-Mail nach einem Link zum Zurücksetzen Ihres Passworts. Es kann bis zu 10 Minuten dauern, bis Sie ankommen.",
    "confirmationCode": "Suchen Sie in Ihrer E-Mail nach einem Bestätigungscode für Ihr neues Konto. Es kann bis zu 10 Minuten dauern, bis Sie ankommen.",
    "setPass": "Geben Sie unten ein neues Passwort für Ihr Konto ein."
  },
  "labels": {
    "firstName": "Vorname",
    "lastName": "Nachname",
    "projectName": "Name des Projekts",
    "email": "E-Mail-Adresse",
    "password": "Passwort",
    "confirmPass": "Passwort wiederholen",
    "verificationCode": "Bestätigungscode"
  },
  "placeholders": {
    "email": "Gib deine E-Mail-Adresse ein",
    "password": "Gib dein Passwort ein",
    "passwordCreate": "Geben Sie Ihr Passwort ein",
    "passwordConfirm": "Geben Sie das Passwort erneut ein"
  },
  "links": {
    "signIn": "Einloggen",
    "forgotPass": "Ich habe mein Passwort vergessen",
    "sendAgain": "Nochmals abschicken",
    "termsAndCo": "Allgemeine Geschäftsbedingungen",
    "back": "Zurück",
    "register": "Registriere dich",
    "loginWithEmail": "Loggen Sie sich stattdessen mit E-Mail ein",
    "loginWithSingleSignOn": "Melden Sie sich mit Single Sign-On an",
    "loginWithMicrosoft": "Melden Sie sich mit Ihrem Microsoft-Konto an"
  },
  "options": {
    "alreadyHaveAccount": "Haben Sie bereits ein Iventis-Konto?",
    "dontHaveAccount": "Sie haben keinen {{ ssoProviderName }}",
    "dontHaveIventis": "Sie haben kein Iventis-Konto?",
    "rememberDetails": "Merken Sie sich meine Daten",
    "notReceived": "Sie haben keine E-Mail erhalten?",
    "consentTos1": "Mit der Erstellung dieses Accounts erkläre ich mich mit den",
    "consentTos2": "der Iventis-Plattform.",
    "verified": "Code erfolgreich verifiziert! Ihr Konto ist jetzt aktiv."
  },
  "passwordConditions": {
    "min8characters": "Mindestens 8 Zeichen",
    "lowercaseLetter": "Enthält einen Kleinbuchstaben",
    "uppercaseLetter": "Enthält einen Großbuchstaben",
    "digit": "Enthält eine Zahl"
  },
  "buttons": {
    "continue": "Fahren Sie fort",
    "login": "Loggen Sie sich ein",
    "sendLink": "Link zum Zurücksetzen senden",
    "createAccount": "Konto erstellen"
  },
  "footer": {
    "terms": "Nutzungsbedingungen",
    "policy": "Datenschutzrichtlinie",
    "contact": "Kontaktiere uns"
  },
  "error": {
    "invalidCode": "Ungültiger Code.",
    "unknownError": "Etwas ist schief gelaufen",
    "failed": "Passwort konnte nicht gesetzt werden. Bitte versuchen Sie es erneut.",
    "required": "Erforderlich",
    "invalid": "Ungültige E-Mail-Adresse",
    "cantFindEmail": "Wir können kein Iventis-Konto finden, das mit dieser E-Mail-Adresse verknüpft ist. Versuchen Sie es erneut oder erstellen Sie ein Konto.",
    "passwordTooLong": "Das Passwort kann maximal 64 Zeichen lang sein",
    "passwordsMustMatch": "Passwörter stimmen nicht überein",
    "mustAgreeToTC": "Um ein Konto zu erstellen, müssen Sie unsere Allgemeinen Geschäftsbedingungen akzeptieren",
    "resetPasswordLinkInvalidTitle": "Link ist abgelaufen",
    "resetPasswordLinkInvalid": "Der Link zum Zurücksetzen Ihres Passworts war ungültig oder abgelaufen. Wir haben einen neuen Link an die mit Ihrem Konto verknüpfte E-Mail-Adresse gesendet. Wenn Sie keinen neuen Link erhalten, versuchen Sie es mit dem unten stehenden Link „Passwort vergessen“ oder wenden Sie sich an",
    "emailInUse": {
      "0": "Diese E-Mail wird bereits verwendet.",
      "1": "Klicken Sie hier",
      "2": "um sich einzuloggen"
    }
  }
}